import React, { useState } from 'react';
import { Heart, Send, CheckCircle } from 'lucide-react';

const PrayerRequest = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    request: '',
    urgent: false
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Mock submission - will be replaced with API call
    console.log('Prayer request submitted:', formData);
    setIsSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({ name: '', email: '', request: '', urgent: false });
      setIsSubmitted(false);
    }, 3000);
  };

  return (
    <div className="page-container prayer-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div 
          className="page-hero-bg" 
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1729089049653-24312fdca908?w=1920)' }}
        >
          <div className="page-hero-overlay" />
        </div>
        <div className="page-hero-content">
          <Heart size={48} className="hero-icon" />
          <h1 className="page-hero-title">Prayer Requests</h1>
          <p className="page-hero-subtitle">
            We believe in the power of prayer and are here to stand with you in faith
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="content-section">
        <div className="container">
          <div className="form-container">
            <div className="form-intro">
              <p>
                At United Christian Fellowship, prayer is at the heart of everything we do. 
                Submit your prayer request, and our leadership and prayer team will stand with 
                you in faith.
              </p>
            </div>

            {isSubmitted ? (
              <div className="success-message">
                <CheckCircle size={64} />
                <h3>Prayer Request Submitted</h3>
                <p>
                  Thank you for sharing your prayer request with us. Our prayer team has been 
                  notified and will be praying for you.
                </p>
              </div>
            ) : (
              <form className="prayer-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Enter your full name"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email (Optional)</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="your.email@example.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="request">Prayer Request *</label>
                  <textarea
                    id="request"
                    name="request"
                    value={formData.request}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Share your prayer request here..."
                  />
                </div>

                <div className="form-group checkbox-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="urgent"
                      checked={formData.urgent}
                      onChange={handleChange}
                    />
                    <span>This is an urgent request</span>
                  </label>
                </div>

                <button type="submit" className="btn btn-primary btn-submit">
                  <Send size={20} />
                  Submit Prayer Request
                </button>

                <p className="form-note">
                  <strong>Note:</strong> All prayer requests are kept confidential.
                </p>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrayerRequest;
